
export default function CoachBio() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <img
          src="https://static.readdy.ai/image/5e5e0a5518213db53ed2e7d68521f761/c795f1a05607f26e0b7605e35bcf9213.jpeg"
          alt="Coach Jakob"
          className="w-48 h-48 rounded-full mx-auto mb-8 object-cover border-4 border-[#E8744F] shadow-lg"
        />

        <div className="uppercase text-xs font-semibold tracking-[0.2em] text-gray-600 mb-3">
          ABOUT YOUR COACH
        </div>

        <h2 className="text-4xl font-bold text-gray-900 mb-8 font-serif">
          Hi, I'm Jakob
        </h2>

        <div className="max-w-2xl mx-auto space-y-6 text-lg text-gray-700 leading-relaxed">
          <p>
            I'm the founder of PACED Coaching. I've coached runners privately and worked with athletes across endurance, strength, and athletic performance. I'm also the Cross Country Assistant Coach for Hidden Valley Middle School.
          </p>

          <p>
            My coaching style blends structured run training with strength and movement work to help athletes stay healthy, consistent, and progressing.
          </p>

          <p className="text-xl italic text-gray-900 font-medium pt-4">
            My focus is simple: sustainable improvement without burnout.
          </p>
        </div>

        {/* Credentials Section */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 font-serif">
            Credentials & Achievements
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
            {/* Coaching Success */}
            <div className="bg-[#F9F8F6] rounded-xl p-6">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                <i className="ri-trophy-line text-3xl text-[#E8744F]"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Coaching Success</h4>
              <p className="text-sm text-gray-700">1x PIAA State Qualifier</p>
              <p className="text-sm text-gray-700">Multiple Overall Winners & Age Group Winners on the Roads and in XC</p>
              <p className="text-sm text-gray-700">Dozens of PRs from the 3k up to Marathon</p>
            </div>

            {/* Personal Records */}
            <div className="bg-[#F9F8F6] rounded-xl p-6">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                <i className="ri-timer-line text-3xl text-[#E8744F]"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Personal Records</h4>
              <ul className="text-sm text-gray-700 space-y-1">
                <li>800m: 2:01</li>
                <li>Mile: 4:34</li>
                <li>5K: 16:20</li>
                <li>10k: 34:29</li>
                <li>Half Marathon: 1:14:23</li>
              </ul>
            </div>

            {/* Competition Highlights */}
            <div className="bg-[#F9F8F6] rounded-xl p-6">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                <i className="ri-medal-line text-3xl text-[#E8744F]"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Competition Highlights</h4>
              <ul className="text-sm text-gray-700 space-y-1">
                <li>School Record 4x800m</li>
                <li>PIAA District 2 AAA Runners Up</li>
                <li>6th Place PIAA District 2 AAA Mile</li>
                <li>2x Shiver by the River 10km Champion</li>
                <li>Scranton Half Marathon 2026 11th Overall</li>
                <li>First Team (2025) & Second Team (2024) All-Conference AEC XC</li>
              </ul>
            </div>

            {/* Certifications */}
            <div className="bg-[#F9F8F6] rounded-xl p-6">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                <i className="ri-file-list-3-line text-3xl text-[#E8744F]"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Certifications</h4>
              <p className="text-sm text-gray-700">UNAA Ninja Coach Certification Level 1</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
